import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export const SelectField = ({ label, value, onChange, options, testid, className = "" }) => (
  <div className={`field ${className}`}>
    <span className="field-label">{label}</span>
    <Select value={String(value)} onValueChange={onChange}>
      <SelectTrigger className="field-input" data-testid={testid}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent {...(window.self !== window.top ? { position: "popper", side: "bottom", avoidCollisions: false } : {})}>
        {options.map((o) => (
          <SelectItem key={o.value} value={String(o.value)} data-testid={`${testid}-option-${o.value}`}>
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export const range = (from, to) => Array.from({ length: to - from + 1 }, (_, i) => ({ value: from + i, label: String(from + i) }));
